import ContentContainer from '../../common/ContentContainer/ContentContainer';

import {
  ContentWrapperStyle,
  HeadingTextWrapperStyle,
  HeadingTextStyle,
  MainContentTextStyle,
  WrapperSection,
  WrapperDiv,
} from './AboutProperties.styles';

import {
  detailsNavigationIdsAndValues,
  detailsNavigationIds,
} from '@stencil/hotels-utils/src/get-details-navigation-id-and-values';

const AboutProperties = ({text = '', desc = '', shortDescSeo = ''}) => {
  return (
    <WrapperSection>
      <WrapperDiv>
        <MainContentTextStyle>
          <HeadingTextWrapperStyle>
            <HeadingTextStyle>{text}</HeadingTextStyle>
          </HeadingTextWrapperStyle>

          <ContentContainer
            heightToBeVisible={84}
            scrollToId={detailsNavigationIdsAndValues.aboutProperty.id}
          >
            {shortDescSeo ? (
              <MainContentTextStyle>
                <p
                  dangerouslySetInnerHTML={{
                    __html: shortDescSeo,
                  }}
                />
                <br />
              </MainContentTextStyle>
            ) : (
              desc && (
                <MainContentTextStyle>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: desc || '',
                    }}
                  />
                </MainContentTextStyle>
              )
            )}
          </ContentContainer>
        </MainContentTextStyle>
      </WrapperDiv>
    </WrapperSection>
  );
};

export default AboutProperties;
